module.exports = __webpack_public_path__ + "static/media/7e06c3e9.jpg";